module.exports = __webpack_public_path__ + "img/2.46987fe1.png";